module.exports = __webpack_public_path__ + "src/img/cookies/iphones-1.ac228.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/iphones-1.png
// module id = 249
// module chunks = 0